(function () {
    XonBoard.Alarms = {
        snd: null,
        selectors: {
            alarm: $('#notify')[0],
        },
        initAudio(file,volume){
            this.snd = new Audio(file);
            volume = volume ? volume : 0.5;
            this.snd.volume = volume;

            this.snd.addEventListener('ended',function(){
                this.pause();
                this.currentTime=0;
            });
        },
        init(audioUrl) {
            this.initAudio(audioUrl);

            this.periodicNotifyIfHasAlarms();
        },
        notifyNow: function () {
            this.snd.play();
        },
        stopNow: function () {
            this.snd.pause();
            this.snd.currentTime = 0;
        },
        periodicNotifyIfHasAlarms: function () {
            setInterval(function () {
                if (!window.Alpine.store('notifications').hasAlarms()) {
                    return;
                }

                XonBoard.Alarms.notifyNow();
            }, 10000);
        },
    };
}());
